"use client";
import React, { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

const vorteile = [
  {
    icon: "ShieldCheckIcon",
    title: "Sauber & sicher",
    desc: "Jeder Build wird mit Sorgfalt montiert – keine losen Kabel, keine Kurzschlüsse, kein Pfusch.",
  },
  {
    icon: "SparklesIcon",
    title: "Kabelmanagement",
    desc: "Dein PC sieht nicht nur gut aus – er ist auch optimal belüftet und klar strukturiert.",
  },
  {
    icon: "ComputerDesktopIcon",
    title: "Windows & Treiber",
    desc: "Frische Windows-Installation, alle Treiber aktuell, direkt einsatzbereit.",
  },
  {
    icon: "BoltIcon",
    title: "Gaming-Optimierung",
    desc: "BIOS-Settings, Windows-Tweaks und FPS-Optimierung für maximale Performance.",
  },
  {
    icon: "ChatBubbleLeftRightIcon",
    title: "Persönliche Beratung",
    desc: "Ich helfe dir beim Auswählen der richtigen Hardware – ehrlich und ohne Verkaufsdruck.",
  },
  {
    icon: "CurrencyDollarIcon",
    title: "Faire Preise",
    desc: "Klare Pakete, keine versteckten Kosten. Qualitätsarbeit zum fairen Preis in der Schweiz.",
  },
];

export default function VorteileSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    const items = sectionRef.current?.querySelectorAll(".reveal-hidden");
    items?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="vorteile" ref={sectionRef} className="relative py-28 lg:py-36 px-6 lg:px-12 overflow-hidden">
      <div className="orb w-[500px] h-[500px] bg-violet-500/5 -top-40 -right-40" />

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-16 reveal-hidden" style={{ transitionDelay: "0ms" }}>
          <div className="section-label mb-4">Warum ich</div>
          <h2 className="font-display font-extrabold text-[clamp(2rem,4vw,3.2rem)] text-white leading-tight">
            Was du bekommst,{" "}
            <span className="gradient-text">was andere nicht bieten</span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {vorteile.map((v, i) => (
            <div
              key={v.title}
              className="service-card reveal-hidden group"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {/* Icon */}
              <div className="relative inline-flex mb-5">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-violet-500/20 to-blue-500/10 border border-violet-500/20 flex items-center justify-center group-hover:border-violet-500/50 transition-colors">
                  <Icon name={v.icon as any} size={22} className="text-violet-400" />
                </div>
              </div>

              <h3 className="font-display font-bold text-lg text-white mb-2">{v.title}</h3>
              <p className="text-sm text-white/45 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}